import { lazy, Suspense, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { RedirecionarExtratos } from './components/RedirecionarExtratos';
import { ErrorBoundaryDeRota } from './components/ErrorBoundary';
const Login = lazy(() => import('./pages/Login').then((m) => ({ default: m.Login })));
// [AB#281] Política de privacidade pública (App Review da Meta).
// [AB#1196] Link público da cobrança — o pagador abre sem login.
const CobrancaPublicaPage = lazy(() =>
  import('./pages/CobrancaPublicaPage').then((m) => ({ default: m.CobrancaPublicaPage })),
);
const PrivacidadePage = lazy(() =>
  import('./pages/PrivacidadePage').then((m) => ({ default: m.PrivacidadePage })),
);
// Termos de Uso — página pública (linkada no /register e rodapé do /login).
const TermosPage = lazy(() =>
  import('./pages/TermosPage').then((m) => ({ default: m.TermosPage })),
);
const Register = lazy(() => import('./pages/Register').then((m) => ({ default: m.Register })));
const EscolherTenant = lazy(() =>
  import('./pages/EscolherTenant').then((m) => ({ default: m.EscolherTenant })),
);
const VerifyOtp = lazy(() => import('./pages/VerifyOtp').then((m) => ({ default: m.VerifyOtp })));
const VerifyEmail = lazy(() =>
  import('./pages/VerifyEmail').then((m) => ({ default: m.VerifyEmail })),
);
const ForgotPassword = lazy(() =>
  import('./pages/ForgotPassword').then((m) => ({ default: m.ForgotPassword })),
);
const ResetPassword = lazy(() =>
  import('./pages/ResetPassword').then((m) => ({ default: m.ResetPassword })),
);
const UnblockAccount = lazy(() =>
  import('./pages/UnblockAccount').then((m) => ({ default: m.UnblockAccount })),
);
const AcceptInvite = lazy(() =>
  import('./pages/AcceptInvite').then((m) => ({ default: m.AcceptInvite })),
);
const SettingsUsers = lazy(() =>
  import('./pages/SettingsUsers').then((m) => ({ default: m.SettingsUsers })),
);
const SettingsPerfis = lazy(() =>
  import('./pages/SettingsPerfis').then((m) => ({ default: m.SettingsPerfis })),
);
const SettingsPerfilEditor = lazy(() =>
  import('./pages/SettingsPerfilEditor').then((m) => ({ default: m.SettingsPerfilEditor })),
);
const SettingsEstabelecimentos = lazy(() =>
  import('./pages/SettingsEstabelecimentos').then((m) => ({ default: m.SettingsEstabelecimentos })),
);
const SettingsEmpresa = lazy(() =>
  import('./pages/SettingsEmpresa').then((m) => ({ default: m.SettingsEmpresa })),
);
const SettingsIntegracoes = lazy(() =>
  import('./pages/SettingsIntegracoes').then((m) => ({ default: m.SettingsIntegracoes })),
);
const Dashboard = lazy(() => import('./pages/Dashboard').then((m) => ({ default: m.Dashboard })));
const InboxPage = lazy(() => import('./pages/InboxPage').then((m) => ({ default: m.InboxPage })));
const ContatoFichaPage = lazy(() =>
  import('./pages/ContatoFichaPage').then((m) => ({ default: m.ContatoFichaPage })),
);
const CrmKanbanPage = lazy(() =>
  import('./pages/CrmKanbanPage').then((m) => ({ default: m.CrmKanbanPage })),
);
// [MOD-05 AB#174] Catálogo Fase 1 — gated por mod_05 no menu.
const CatalogoPage = lazy(() =>
  import('./pages/CatalogoPage').then((m) => ({ default: m.CatalogoPage })),
);
// [MOD-07 AB#300] Fornecedores — subfunção do mod_05 (menu Catálogo). Página
// com tabs Fornecedores + Tipos (a TiposFornecedorPage virou tab, sem rota própria).
const FornecedoresPage = lazy(() =>
  import('./pages/FornecedoresPage').then((m) => ({ default: m.FornecedoresPage })),
);
// [AB#645 / MOD-FIN] Contas — gating mod_07 no backend e no nav-config.
const ContasPage = lazy(() =>
  import('./pages/ContasPage').then((m) => ({ default: m.ContasPage })),
);
// [AB#648] Títulos — uma página, direção pela query string.
const ConciliacaoPage = lazy(() =>
  import('./pages/ConciliacaoPage').then((m) => ({ default: m.ConciliacaoPage })),
);
const RedirecionaRegrasConciliacao = lazy(() =>
  import('./pages/RegrasConciliacaoPage').then((m) => ({ default: m.RedirecionaRegrasConciliacao })),
);
// [AB#1107 / ADR-074 Adendo 3] Cobrança bancária — módulo próprio, menu separado de Conciliação.
const PagamentosPage = lazy(() =>
  import('./pages/PagamentosPage').then((m) => ({ default: m.PagamentosPage })),
);
const CobrancaBancariaPage = lazy(() =>
  import('./pages/CobrancaBancariaPage').then((m) => ({ default: m.CobrancaBancariaPage })),
);
const TitulosPage = lazy(() =>
  import('./pages/TitulosPage').then((m) => ({ default: m.TitulosPage })),
);
// [AB#649] CRUD de Plano de Contas e Centro de Custo — páginas próprias.
const ParametrosPage = lazy(() =>
  import('./pages/ParametrosPage').then((m) => ({ default: m.ParametrosPage })),
);
const FechamentoFiscalPage = lazy(() =>
  import('./pages/FechamentoFiscalPage').then((m) => ({ default: m.FechamentoFiscalPage })),
);
const PlanoContasPage = lazy(() =>
  import('./pages/PlanoContasPage').then((m) => ({ default: m.PlanoContasPage })),
);
// [ADR-061 F1 US3, mod_09] Plano contábil — distinto do plano financeiro acima.
const PlanoContabilPage = lazy(() =>
  import('./pages/PlanoContabilPage').then((m) => ({ default: m.PlanoContabilPage })),
);
// [ADR-061 D2/D6, US5] Mapeamento contábil — de-para financeiro/operacional → plano contábil.
const BalancetePage = lazy(() =>
  import('./pages/BalancetePage').then((m) => ({ default: m.BalancetePage })),
);
const RazaoPage = lazy(() =>
  import('./pages/RazaoPage').then((m) => ({ default: m.RazaoPage })),
);
const DiarioPage = lazy(() =>
  import('./pages/DiarioPage').then((m) => ({ default: m.DiarioPage })),
);
const DrePage = lazy(() => import('./pages/DrePage').then((m) => ({ default: m.DrePage })));
const DreEstruturaPage = lazy(() =>
  import('./pages/DreEstruturaPage').then((m) => ({ default: m.DreEstruturaPage })),
);
const MapeamentoContabilPage = lazy(() =>
  import('./pages/MapeamentoContabilPage').then((m) => ({ default: m.MapeamentoContabilPage })),
);
const LancamentosPage = lazy(() =>
  import('./pages/LancamentosPage').then((m) => ({ default: m.LancamentosPage })),
);
const CentroCustoPage = lazy(() =>
  import('./pages/CentroCustoPage').then((m) => ({ default: m.CentroCustoPage })),
);
// [ADR-064 D12, U1b] Rota-ponte do sino — orçamento não tem tela própria,
// redireciona pro drawer do Negócio no CRM (aba Orçamentos).
const OrcamentoBridgePage = lazy(() =>
  import('./pages/OrcamentoBridgePage').then((m) => ({ default: m.OrcamentoBridgePage })),
);
// [MOD-04 AB#169] Agenda Fase 1 — visão semana/dia + criar agendamento.
const AgendaPage = lazy(() =>
  import('./pages/AgendaPage').then((m) => ({ default: m.AgendaPage })),
);
const SettingsComercialCaixas = lazy(() =>
  import('./pages/SettingsComercialCaixas').then((m) => ({
    default: m.SettingsComercialCaixas,
  })),
);
// [AB#157] Painel de configuração da Atena por caixa.
const SettingsCaixaIa = lazy(() =>
  import('./pages/SettingsCaixaIa').then((m) => ({
    default: m.SettingsCaixaIa,
  })),
);
const SettingsComercialCrm = lazy(() =>
  import('./pages/SettingsComercialCrm').then((m) => ({
    default: m.SettingsComercialCrm,
  })),
);
const AutomacoesPage = lazy(() =>
  import('./pages/AutomacoesPage').then((m) => ({
    default: m.AutomacoesPage,
  })),
);
// [AB#449 / ADR-045] Gestão das respostas rápidas do inbox.
const TemplatesAtendimentoPage = lazy(() =>
  import('./pages/TemplatesAtendimentoPage').then((m) => ({
    default: m.TemplatesAtendimentoPage,
  })),
);
// [AB#264] As telas de Configuração de Campanhas e Opt-outs viraram tabs do
// guarda-chuva /comercial/campanhas. As rotas antigas redirecionam (abaixo).
const CampanhasPage = lazy(() =>
  import('./pages/CampanhasPage').then((m) => ({ default: m.CampanhasPage })),
);
const CampanhaDetalhePage = lazy(() =>
  import('./pages/CampanhaDetalhePage').then((m) => ({ default: m.CampanhaDetalhePage })),
);
const ImpersonateApprove = lazy(() =>
  import('./pages/ImpersonateApprove').then((m) => ({ default: m.ImpersonateApprove })),
);
const ImpersonateFeedback = lazy(() =>
  import('./pages/ImpersonateFeedback').then((m) => ({ default: m.ImpersonateFeedback })),
);
const AdminImpersonate = lazy(() =>
  import('./pages/AdminImpersonate').then((m) => ({ default: m.AdminImpersonate })),
);
const AdminSegmentos = lazy(() =>
  import('./pages/AdminSegmentos').then((m) => ({ default: m.AdminSegmentos })),
);
const AdminFaturamentoVinya = lazy(() =>
  import('./pages/AdminFaturamentoVinya').then((m) => ({ default: m.AdminFaturamentoVinya })),
);
const AdminSystemSettings = lazy(() =>
  import('./pages/AdminSystemSettings').then((m) => ({ default: m.AdminSystemSettings })),
);
const AdminModulos = lazy(() =>
  import('./pages/AdminModulos').then((m) => ({ default: m.AdminModulos })),
);
const AdminTemplatesMensagem = lazy(() =>
  import('./pages/AdminTemplatesMensagem').then((m) => ({ default: m.AdminTemplatesMensagem })),
);
const AdminDocumentosLegais = lazy(() =>
  import('./pages/AdminDocumentosLegais').then((m) => ({ default: m.AdminDocumentosLegais })),
);
const AdminReleaseNotes = lazy(() =>
  import('./pages/AdminReleaseNotes').then((m) => ({ default: m.AdminReleaseNotes })),
);
const AdminComunicados = lazy(() =>
  import('./pages/AdminComunicados').then((m) => ({ default: m.AdminComunicados })),
);
const AdminPlanos = lazy(() =>
  import('./pages/AdminPlanos').then((m) => ({ default: m.AdminPlanos })),
);
const AdminTenants = lazy(() =>
  import('./pages/AdminTenants').then((m) => ({ default: m.AdminTenants })),
);
const AdminTenantDetalhe = lazy(() =>
  import('./pages/AdminTenantDetalhe').then((m) => ({ default: m.AdminTenantDetalhe })),
);
const Upgrade = lazy(() => import('./pages/Upgrade').then((m) => ({ default: m.Upgrade })));
const AdminDashboard = lazy(() =>
  import('./pages/AdminDashboard').then((m) => ({ default: m.AdminDashboard })),
);
const MinhaContaChamados = lazy(() =>
  import('./pages/MinhaContaChamados').then((m) => ({ default: m.MinhaContaChamados })),
);
const MinhaContaChamadoDetalhe = lazy(() =>
  import('./pages/MinhaContaChamadoDetalhe').then((m) => ({ default: m.MinhaContaChamadoDetalhe })),
);
const MinhaContaNotasFiscais = lazy(() =>
  import('./pages/MinhaContaNotasFiscais').then((m) => ({ default: m.MinhaContaNotasFiscais })),
);
const AdminChamados = lazy(() =>
  import('./pages/AdminChamados').then((m) => ({ default: m.AdminChamados })),
);
const AdminChamadoDetalhe = lazy(() =>
  import('./pages/AdminChamadoDetalhe').then((m) => ({ default: m.AdminChamadoDetalhe })),
);
import { AceitePendenteModal } from './components/AceitePendenteModal';
import { ReleaseNotesModal } from './components/ReleaseNotesModal';
import { AdminRoute } from './components/AdminRoute';
import { RequerPermissaoRota } from './components/RequerPermissaoRota';
import { GuardDirecaoTitulos } from './components/GuardDirecaoTitulos';
import { RedirecionarLegadoFinanceiro } from './components/RedirecionarLegadoFinanceiro';
import { ROTAS_LEGADAS_FINANCEIRO } from './lib/rotas-legadas-financeiro';
import { leituraDaTela } from './lib/telas-acesso';
const AuditLog = lazy(() => import('./pages/AuditLog').then((m) => ({ default: m.AuditLog })));
const AdminAuditLog = lazy(() =>
  import('./pages/AdminAuditLog').then((m) => ({ default: m.AdminAuditLog })),
);
const TrialExpirado = lazy(() =>
  import('./pages/TrialExpirado').then((m) => ({ default: m.TrialExpirado })),
);
const TrocarSenhaObrigatoria = lazy(() =>
  import('./pages/TrocarSenhaObrigatoria').then((m) => ({ default: m.TrocarSenhaObrigatoria })),
);
const ContaSuspensa = lazy(() =>
  import('./pages/ContaSuspensa').then((m) => ({ default: m.ContaSuspensa })),
);
const PropostaSegmento = lazy(() =>
  import('./pages/PropostaSegmento').then((m) => ({ default: m.PropostaSegmento })),
);
const Faq = lazy(() => import('./pages/Faq').then((m) => ({ default: m.Faq })));
const FaqArtigo = lazy(() => import('./pages/FaqArtigo').then((m) => ({ default: m.FaqArtigo })));
const AdminFaq = lazy(() => import('./pages/AdminFaq').then((m) => ({ default: m.AdminFaq })));
const AdminInadimplencia = lazy(() =>
  import('./pages/AdminInadimplencia').then((m) => ({ default: m.AdminInadimplencia })),
);
const AdminFinanceiroOperacoes = lazy(() =>
  import('./pages/AdminFinanceiroOperacoes').then((m) => ({ default: m.AdminFinanceiroOperacoes })),
);
const AdminSistemaMonitoramento = lazy(() =>
  import('./pages/AdminSistemaMonitoramento').then((m) => ({
    default: m.AdminSistemaMonitoramento,
  })),
);
const AdminPerfil = lazy(() =>
  import('./pages/AdminPerfil').then((m) => ({ default: m.AdminPerfil })),
);
const MinhaContaPerfil = lazy(() =>
  import('./pages/MinhaContaPerfil').then((m) => ({ default: m.MinhaContaPerfil })),
);
const GoogleCalendarSucesso = lazy(() =>
  import('./pages/GoogleCalendarSucesso').then((m) => ({ default: m.GoogleCalendarSucesso })),
);
const MinhaContaAssinatura = lazy(() =>
  import('./pages/MinhaContaAssinatura').then((m) => ({ default: m.MinhaContaAssinatura })),
);
// [AB#456 p2] Extrato de consumo de IA — sub-rota da assinatura, com gráficos.
const ExtratoIaPage = lazy(() =>
  import('./pages/ExtratoIaPage').then((m) => ({ default: m.ExtratoIaPage })),
);
const MinhaContaAssinaturaPagamentos = lazy(() =>
  import('./pages/MinhaContaAssinaturaPagamentos').then((m) => ({
    default: m.MinhaContaAssinaturaPagamentos,
  })),
);
import { ImpersonateBanner } from './components/ImpersonateBanner';
import { TrialBanner } from './components/TrialBanner';
import { PropostaSegmentoBanner } from './components/PropostaSegmentoBanner';
import { AtualizacaoMinorBanner } from './components/AtualizacaoMinorBanner';
import { useSidebarCollapse } from './lib/use-sidebar-collapse';
import { onAuthBroadcast } from './lib/auth-broadcast';
import { useActivityHeartbeat } from './lib/use-activity-heartbeat';
import { limparExpirados } from './lib/arquivo-persistido';
import { useAuthStore } from './store/auth.store';
import { useBrandingStore } from './store/branding.store';
import { useModulosStore } from './store/modulos.store';
import { useModulosTrialStore } from './store/modulos-trial.store';
import { useEstabelecimentosStore } from './store/estabelecimentos.store';
import { useAcessoStore, temAtribuicaoRbac } from './store/acesso.store';
import { useEstabelecimentoAtivoStore } from './store/estabelecimento-ativo.store';
import { useEmpresaIdentidadeStore } from './store/empresa-identidade.store';
import { ToastProvider } from './components/ui';
import { AdminLayout } from './components/layout/AdminLayout';
import { TenantLayout } from './components/layout/TenantLayout';
import { FaqShellAware } from './components/layout/FaqShellAware';

/**
 * Escuta o canal BroadcastChannel('auth') (REQ-003 / AB#25): quando outra aba
 * faz LOGOUT, esta aba limpa a sessão local e vai para /login.
 */
function AuthSync(): null {
  const navigate = useNavigate();
  const clear = useAuthStore((s) => s.clear);
  useEffect(
    () =>
      onAuthBroadcast((msg) => {
        if (msg.type === 'LOGOUT') {
          clear();
          navigate('/login');
        }
        // LOGIN: opcional — reservado para futura revalidação cross-tab.
      }),
    [navigate, clear],
  );
  return null;
}

/** Carrega branding (app_nome / app_url) no boot. AB#61 bug 2. */
function BrandingBoot(): null {
  const recarregar = useBrandingStore((s) => s.recarregar);
  useEffect(() => {
    void recarregar();
  }, [recarregar]);
  return null;
}

/**
 * [PERF] Prefetch das páginas mais visitadas em background.
 *
 * Depois do code-splitting + lazy() (commits 0a19bae / c85feca), a
 * primeira visita a cada rota baixa o chunk dela — flash de Skeleton
 * por uns 200-500ms. Aqui disparamos `import()` em background para os
 * destinos comuns (login, dashboards, telas que todo tenant abre cedo)
 * usando `requestIdleCallback`: o browser só baixa quando estiver
 * ocioso, então não rouba banda do shell ou do 1º paint.
 *
 * Ordem importa pouco — todos vão pra cache do módulo, não há ordering.
 * Fallback `setTimeout(1000)` cobre Safari < 15 (sem requestIdleCallback).
 *
 * Páginas pesadas que só Super Admin vê em telas específicas
 * (AdminDashboard com mapa/charts, AdminTenantDetalhe) ficam de fora —
 * o usuário comum não precisa baixá-las.
 */
function PrefetchPaginas(): null {
  useEffect(() => {
    const prefetch = (): void => {
      // Páginas que quase todo usuário visita cedo.
      void import('./pages/Dashboard');
      void import('./pages/Login');
      // Super Admin
      void import('./pages/AdminDashboard');
      void import('./pages/AdminTenants');
      // Tenant
      void import('./pages/MinhaContaAssinatura');
      void import('./pages/SettingsUsers');
    };
    const idle = (
      window as Window & {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
        cancelIdleCallback?: (id: number) => void;
      }
    ).requestIdleCallback;
    if (typeof idle === 'function') {
      const id = idle(prefetch, { timeout: 3000 });
      return () => {
        const cancel = (window as Window & { cancelIdleCallback?: (id: number) => void })
          .cancelIdleCallback;
        if (typeof cancel === 'function') cancel(id);
      };
    }
    const id = window.setTimeout(prefetch, 1000);
    return () => window.clearTimeout(id);
  }, []);
  return null;
}

/**
 * Carrega os módulos do tenant logado (AB#68 + AB#69). Reage à presença
 * do `usuario` no auth.store: ao login ⇒ recarrega; ao logout ⇒ limpa.
 * Refetch quando a aba volta a ficar visível, pegando ativações feitas
 * pelo Super Admin em outra aba sem precisar de F5.
 */
function ModulosBoot(): null {
  const usuario = useAuthStore((s) => s.usuario);
  const recarregar = useModulosStore((s) => s.recarregar);
  const limpar = useModulosStore((s) => s.limpar);
  // [UI-ASSINATURA] Trial individual segue o ciclo de sessão: limpa no logout
  // pra a próxima sessão começar do zero (sem dados do tenant anterior).
  const limparTrial = useModulosTrialStore((s) => s.limpar);
  useEffect(() => {
    if (!usuario) {
      limpar();
      limparTrial();
      return;
    }
    void recarregar();
    // [fix refresh-sistêmico] Listener `visibilitychange` REMOVIDO.
    //
    // Antes: cada vez que a aba ganhava foco, disparava refetch dos
    // módulos. Combinado com o `set({ carregando: true })` no início
    // do recarregar, isso causava flash sistêmico (menu + dropdowns
    // gated por módulo recalculavam) — perceptível em QA.
    //
    // Módulos não mudam a cada foco — refresh a cada foco era
    // refetch desnecessário. O recarregar() segue disparando uma vez
    // quando `usuario` muda (login/boot). Se um dia precisar
    // revalidar numa sessão longa, fazer com throttle (só após
    // N min do último fetch), NÃO a cada foco.
  }, [usuario, recarregar, limpar, limparTrial]);
  return null;
}

/**
 * [fix refresh-sistêmico] Carrega os estabelecimentos do tenant logado
 * UMA VEZ no boot e popula o `estabelecimentos.store` (cache global).
 *
 * Antes deste boot, 3 telas (Dashboard, Inbox, CRM) e o ModalCaixa
 * faziam `apiFetch('/estabelecimentos')` independentes em mount, o que
 * gerava 3-4 requests pro mesmo endpoint e flash do `SeletorEstabelecimento`
 * em single-unit (cada tela esperava o fetch). Agora todas as telas
 * leem o store; o request acontece 1x por sessão.
 *
 * Limpa no logout pra próxima sessão começar do zero (cache do tenant
 * anterior fica fora). Padrão idêntico ao `ModulosBoot`.
 */
function EstabelecimentosBoot(): null {
  const usuario = useAuthStore((s) => s.usuario);
  const recarregar = useEstabelecimentosStore((s) => s.recarregar);
  const limpar = useEstabelecimentosStore((s) => s.limpar);
  // [D10 #915 / ADR-069 §13.27] Espera o AcessoBoot resolver antes de decidir: usuário com pelo
  // menos uma UsuarioAcesso não depende mais deste cache (SeletorEstabelecimento lê /auth/me),
  // então buscar GET /estabelecimentos pra ele seria desperdício (rota só-ADMIN no legado — 403
  // certo pra Atendente/Financeiro/etc.). Sem nenhuma atribuição, cai pra este fallback legado
  // assim que o AcessoBoot confirmar isso — é seleção de FONTE DE DADOS (não um bypass de
  // permissão; o próprio `@Roles` do endpoint legado protege), ver nota completa em
  // `acesso.store.ts` (`temAtribuicaoRbac`).
  const acesso = useAcessoStore((s) => s.acesso);
  const acessoCarregado = useAcessoStore((s) => s.carregado);
  useEffect(() => {
    if (!usuario) {
      limpar();
      return;
    }
    // SUPER_ADMIN não tem estabelecimentos de tenant — pula fetch (o
    // backend devolveria 403 ou vazio dependendo da rota). Mesmo critério
    // usado em outras telas que evitam payload de tenant pra SA.
    if (usuario.perfil === 'SUPER_ADMIN') return;
    if (!acessoCarregado) return;
    if (temAtribuicaoRbac(acesso)) return;
    void recarregar();
  }, [usuario, recarregar, limpar, acesso, acessoCarregado]);
  return null;
}

/**
 * [ADR-069 §3/§13.3 / D10 #915] Carrega o `acesso` (ResumoAcesso) do `/auth/me`
 * UMA VEZ no boot — mesmo padrão de `EstabelecimentosBoot`, store separada
 * (`acesso.store.ts`). É a fonte que `SeletorEstabelecimento` passa a preferir
 * quando o usuário já tem alguma `UsuarioAcesso` (RBAC); sem nenhuma, o
 * componente cai para o `EstabelecimentosBoot`/`useEstabelecimentosStore`
 * legado (usuário ainda não passou pelo backfill, D10).
 */
function AcessoBoot(): null {
  const usuario = useAuthStore((s) => s.usuario);
  const carregar = useAcessoStore((s) => s.carregar);
  const limpar = useAcessoStore((s) => s.limpar);
  useEffect(() => {
    if (!usuario) {
      limpar();
      return;
    }
    // SUPER_ADMIN não tem UsuarioAcesso de tenant — pula fetch (mesmo
    // critério do EstabelecimentosBoot).
    if (usuario.perfil === 'SUPER_ADMIN') return;
    void carregar();
  }, [usuario, carregar, limpar]);
  return null;
}

/**
 * [Logo do tenant — SUBBAR] Carrega `nome_empresa`/`logo_url` do tenant
 * logado UMA VEZ no boot — mesmo padrão de `EstabelecimentosBoot` (reage ao
 * `usuario` do auth.store, pula SUPER_ADMIN — sem tenant próprio pra
 * identidade, limpa no logout).
 */
function EmpresaIdentidadeBoot(): null {
  const usuario = useAuthStore((s) => s.usuario);
  const recarregar = useEmpresaIdentidadeStore((s) => s.recarregar);
  const limpar = useEmpresaIdentidadeStore((s) => s.limpar);
  useEffect(() => {
    if (!usuario) {
      limpar();
      return;
    }
    if (usuario.perfil === 'SUPER_ADMIN') return;
    void recarregar();
  }, [usuario, recarregar, limpar]);
  return null;
}

/**
 * [#916] Zera o estabelecimento ativo global no logout — a próxima sessão
 * (mesmo navegador, outro usuário/tenant) começa do zero; quem repovoa é o
 * `<SeletorEstabelecimento>` do `AppShell` (single-unit/preferencial/D10).
 */
function EstabelecimentoAtivoBoot(): null {
  const usuario = useAuthStore((s) => s.usuario);
  const limpar = useEstabelecimentoAtivoStore((s) => s.limpar);
  useEffect(() => {
    if (!usuario) limpar();
  }, [usuario, limpar]);
  return null;
}

/**
 * Heartbeat de inatividade baseado em interação humana real (REQ-003
 * RN-02 / AB#85). Hook registra listeners no document e dispara
 * `POST /auth/heartbeat` no máximo 1x a cada 30s — só quando o usuário
 * mexe no mouse, digita, scrolla ou toca a tela. Render `null` igual
 * aos outros boots (`BrandingBoot`, `ModulosBoot`).
 */
function ActivityHeartbeat(): null {
  useActivityHeartbeat();
  return null;
}

/**
 * Rotas onde os banners autenticados (Trial / Proposta de Segmento /
 * Impersonate) NÃO devem aparecer — fluxos de login/registro/recuperação
 * etc. são contextos fora da sessão do tenant. Corrige o bug do TrialBanner
 * aparecendo no /login quando o usuário ainda está com sessão no store.
 */
const ROTAS_SEM_BANNERS = new Set<string>([
  '/login',
  '/register',
  '/verify-otp',
  '/escolher-tenant',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
  '/unblock-account',
  '/accept-invite',
  '/trial-expirado',
  '/conta-suspensa',
  '/trocar-senha',
  '/upgrade',
  // [AB#281] Página pública de privacidade — sem banners/sino mesmo se houver sessão.
  '/privacidade',
  // Termos de Uso — página pública, mesmo tratamento.
  '/termos',
]);

/**
 * FAQ pública é acessível sem login — mas se houver sessão, o usuário
 * já está dentro do app e os banners/sino têm contexto. Por isso o /faq
 * NÃO entra em ROTAS_SEM_BANNERS — banners aparecem se logado, somem se
 * não. O matcher tem que cobrir `/faq` exato e `/faq/<slug>`.
 */
function rotaPublicaFaq(pathname: string): boolean {
  return pathname === '/faq' || pathname.startsWith('/faq/');
}

function BannersGlobais(): JSX.Element | null {
  const { pathname } = useLocation();
  const { collapsed } = useSidebarCollapse();
  const ref = useRef<HTMLDivElement>(null);
  const oculto =
    ROTAS_SEM_BANNERS.has(pathname) || rotaPublicaFaq(pathname) || pathname.startsWith('/c/');

  // [AB#415] Expõe a altura REAL dos banners como `--banners-h` no <html>.
  // Páginas de altura fixa (ex.: InboxPage usa `calc(100dvh - ...)`) precisam
  // descontar essa altura — senão o container passa da viewport e corta o
  // conteúdo do rodapé (o composer do inbox). O ResizeObserver cobre qualquer
  // combinação/mudança de banners (impersonate/trial/proposta/atualização)
  // sem hardcode de altura. Sem banner (ou rota oculta) → 0px.
  useLayoutEffect(() => {
    const root = document.documentElement;
    const el = ref.current;
    if (oculto || !el) {
      root.style.setProperty('--banners-h', '0px');
      return;
    }
    const aplicar = (): void =>
      root.style.setProperty('--banners-h', `${el.offsetHeight}px`);
    aplicar();
    const ro = new ResizeObserver(aplicar);
    ro.observe(el);
    return () => {
      ro.disconnect();
      root.style.setProperty('--banners-h', '0px');
    };
  }, [oculto]);

  if (oculto) return null;
  // [AB#209] Os banners são renderizados no root do App, FORA do AppShell —
  // sem offset, o `w-full` deles ficava por baixo do sidebar `fixed z-50`
  // (cortado na esquerda). Espelhamos o mesmo deslocamento do conteúdo do
  // AppShell (marginLeft = largura do sidebar, reagindo ao colapso) pra que
  // o banner viva na área de conteúdo. Exceção: rotas full-screen sem shell
  // (/impersonate/*) continuam full-width. Todas as outras rotas com banner
  // usam AppShell (TenantLayout/AdminLayout, mesmo --sidebar-w).
  const semShell = pathname.startsWith('/impersonate/');
  return (
    <div
      ref={ref}
      className="transition-[margin-left] duration-[260ms] ease-[var(--ease)]"
      style={
        semShell
          ? undefined
          : { marginLeft: collapsed ? 'var(--sidebar-w-collapsed)' : 'var(--sidebar-w)' }
      }
    >
      <ImpersonateBanner />
      <TrialBanner />
      <PropostaSegmentoBanner />
      <AtualizacaoMinorBanner />
    </div>
  );
}


export function App() {
  // [fix cold-start] Gate de hidratação do `auth.store`. O persist do
  // Zustand aplica o snapshot do localStorage de forma assíncrona; se
  // montássemos as rotas antes disso, o primeiro paint usaria o estado
  // inicial (autenticado=false, usuario=null) e o React decidiria pela
  // rota errada. Quando o persist termina, o estado muda e a árvore
  // remonta — visível como "pisca branco e remonta" em cold start.
  //
  // Detecção: API oficial `useAuthStore.persist.hasHydrated()` +
  // `onFinishHydration` (zustand v4). Mais robusto que setar uma flag
  // dentro de `onRehydrateStorage` — esta API foi feita exatamente
  // pra esse caso. Em cold start no SSR/CSR, hasHydrated() pode
  // retornar true imediatamente (snapshot do localStorage carregado
  // sincronamente); se já estiver true no useState inicial, o gate
  // não chega a aparecer.
  //
  // Boots (BrandingBoot, ModulosBoot, EstabelecimentosBoot, AcessoBoot, EmpresaIdentidadeBoot) ficam
  // DENTRO do router — só rodam pós-hidratação, que é o que eles
  // precisam (dependem de `usuario` do auth.store).
  const [hidratado, setHidratado] = useState<boolean>(() => useAuthStore.persist.hasHydrated());
  // [AB#1173] Abertura do app: remove do IndexedDB os arquivos de carga em massa com mais de 24 h.
  useEffect(() => {
    void limparExpirados();
  }, []);
  useEffect(() => {
    // Se já hidratou antes deste effect rodar, nada a fazer.
    if (useAuthStore.persist.hasHydrated()) {
      setHidratado(true);
      return;
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => {
      setHidratado(true);
    });
    return unsub;
  }, []);
  if (!hidratado) return <PageSkeleton />;
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthSync />
        <BrandingBoot />
        <PrefetchPaginas />
        <ModulosBoot />
        <EstabelecimentosBoot />
        <AcessoBoot />
        <EmpresaIdentidadeBoot />
        <EstabelecimentoAtivoBoot />
        <ActivityHeartbeat />
        <BannersGlobais />
        <AceitePendenteModal />
        <ReleaseNotesModal />
        {/* [AB#1030] Rede de segurança pras rotas SEM AppShell (login, registro, páginas públicas);
            as telas com shell têm o boundary próprio dentro do <main> (menu/header sobrevivem). */}
        <ErrorBoundaryDeRota variante="pagina">
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/escolher-tenant" element={<EscolherTenant />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/unblock-account" element={<UnblockAccount />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            {/* Páginas full-screen sem shell: trial expirado, conta suspensa
            e telas de impersonate — fluxos de bloqueio/aprovação que ficam
            fora da navegação normal. */}
            <Route path="/impersonate/aprovar" element={<ImpersonateApprove />} />
            <Route path="/impersonate/feedback" element={<ImpersonateFeedback />} />
            <Route path="/trial-expirado" element={<TrialExpirado />} />
            <Route path="/conta-suspensa" element={<ContaSuspensa />} />
            {/* [AB#1282] Troca obrigatória da senha provisória (conta criada direto pelo admin). */}
            <Route path="/trocar-senha" element={<TrocarSenhaObrigatoria />} />
            {/* [AB#1196] Link da cobrança — PÚBLICA, sem auth; o token assinado na URL é a autorização. */}
            <Route path="/c/:token" element={<CobrancaPublicaPage />} />
            {/* [AB#281] Política de privacidade — PÚBLICA, sem auth (Meta App Review). */}
            <Route path="/privacidade" element={<PrivacidadePage />} />
            {/* Termos de Uso — PÚBLICA, sem auth. Linkada no /register e /login. */}
            <Route path="/termos" element={<TermosPage />} />

            {/* /faq e /faq/:slug são semi-públicas — funcionam sem login. O
            FaqShellAware envolve o conteúdo no TenantLayout quando há
            sessão, preservando a sidebar; visitante anônimo vê a página
            crua (mesma URL, sem shell). */}
            <Route
              path="/faq"
              element={
                <FaqShellAware>
                  <Faq />
                </FaqShellAware>
              }
            />
            <Route
              path="/faq/:slug"
              element={
                <FaqShellAware>
                  <FaqArtigo />
                </FaqShellAware>
              }
            />

            {/* Rotas tenant logadas — [UI-TENANT] envolvidas pelo TenantLayout
            do Design System v2 (sidebar + topbar + breadcrumb). */}
            <Route element={<TenantLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              {/* [MOD-03 AB#112] Inbox unificado. Gating por mod_03 é feito
              no backend (ModuloGuard global) — frontend mostra a tela
              normalmente; ModuloTrialBanner sinaliza trial/bloqueio.
              [F4.3 #890] Gate de permissão (UX) casado com nav-config.ts. */}
              <Route
                path="/comercial/inbox"
                element={<RequerPermissaoRota codigo={leituraDaTela('com-inbox')}><InboxPage /></RequerPermissaoRota>}
              />
              {/* [MOD-03 AB#130] CRM — Kanban + lista. Gating mod_03 no backend. */}
              <Route
                path="/comercial/crm"
                element={<RequerPermissaoRota codigo={leituraDaTela('com-crm')}><CrmKanbanPage /></RequerPermissaoRota>}
              />
              {/* [ADR-047 fatia 3] Ficha do contato. A MESMA tela abre em
              drawer a partir do inbox — o componente não conhece rota.
              [F4.3 #890] Deep-link de detalhe, fora do nav — sem gate de rota aqui
              (mesmo critério dos demais :id, ver nota abaixo). */}
              <Route path="/comercial/crm/contatos/:id" element={<ContatoFichaPage />} />
              {/* [MOD-03 AB#230] Campanhas — listagem + detalhe. Gating mod_03 no backend. */}
              <Route
                path="/comercial/campanhas"
                element={<RequerPermissaoRota codigo={leituraDaTela('com-cmp')}><CampanhasPage /></RequerPermissaoRota>}
              />
              <Route path="/comercial/campanhas/:id" element={<CampanhaDetalhePage />} />
              {/* [MOD-04 AB#169] Agenda — visão semana/dia. Backend gate mod_04. */}
              <Route
                path="/agenda"
                element={<RequerPermissaoRota codigo={leituraDaTela('agenda')}><AgendaPage /></RequerPermissaoRota>}
              />
              {/* [MOD-05 AB#174 / AB#307] Catálogo em /catalogo; /vendas/catalogo
              (legado) redireciona preservando ?tab. */}
              <Route
                path="/catalogo"
                element={<RequerPermissaoRota codigo={leituraDaTela('cat-itens')}><CatalogoPage /></RequerPermissaoRota>}
              />
              <Route
                path="/vendas/catalogo"
                element={<Navigate to="/catalogo" replace />}
              />
              {/* [F4.4 #890] Corrigido — fornecedor é `parte`, não `catalogo.item` (F4.3
              reusava catalogo.item:ler por não achar recurso dedicado). */}
              <Route
                path="/catalogo/fornecedores"
                element={<RequerPermissaoRota codigo={leituraDaTela('cat-fornecedores')}><FornecedoresPage /></RequerPermissaoRota>}
              />
              <Route
                path="/financeiro/contas"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-contas')}><ContasPage /></RequerPermissaoRota>}
              />
              <Route
                path="/financeiro/conciliacao"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-conciliacao')}><ConciliacaoPage /></RequerPermissaoRota>}
              />
              <Route
                path="/financeiro/conciliacao/regras"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-conciliacao-regras')}><RedirecionaRegrasConciliacao /></RequerPermissaoRota>}
              />
              {/* [AB#1107 / ADR-074 Adendo 3] Módulo próprio — permissão fin.cobranca, não fin.conciliacao. Uma tela com
              abas (?aba=): Boletos e Pix | Lotes | Regra automática | Retornos. */}
              <Route
                path="/financeiro/cobranca"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-cobranca')}><CobrancaBancariaPage /></RequerPermissaoRota>}
              />
              {/* Extratos saiu do menu: o extrato abre em Contas bancárias (ícone ao lado do nome). `?conta=ID` abre o da conta. */}
              <Route path="/financeiro/extratos/*" element={<RedirecionarExtratos />} />
              {/* [AB#1215 / ADR-082 D7] Pagamentos (Contas a pagar): Agenda | Lotes. Passa com QUALQUER das duas leituras;
              cada aba some sozinha sem a sua. */}
              <Route
                path="/financeiro/pagamentos"
                element={
                  <RequerPermissaoRota codigo={[...leituraDaTela('fin-agenda-pagamentos'), ...leituraDaTela('fin-remessas-pagamento')]}>
                    <PagamentosPage />
                  </RequerPermissaoRota>
                }
              />
              {/* Rotas antigas (Cobrança bancária, Borderôs, Agenda/Remessas) → tela + aba novas, mantendo a query. */}
              {[...ROTAS_LEGADAS_FINANCEIRO, '/financeiro/cobranca-bancaria'].map((caminho) => (
                <Route key={caminho} path={caminho} element={<RedirecionarLegadoFinanceiro />} />
              ))}
              {/* [AB#648 / F4.4 #890 Decisão 1] Uma rota só, direção na query — guarda
              dedicado (não o RequerPermissaoRota genérico) porque a permissão exigida
              depende de QUAL direção está na URL agora, não só "tem uma das duas". */}
              <Route
                path="/financeiro/titulos"
                element={<GuardDirecaoTitulos><TitulosPage /></GuardDirecaoTitulos>}
              />
              {/* [US 974 UI] Plano de contas migrou para o menu Contabilidade; a rota antiga redireciona. */}
              <Route
                path="/financeiro/plano-de-contas"
                element={<Navigate to="/contabilidade/plano-de-contas" replace />}
              />
              <Route
                path="/contabilidade/plano-de-contas"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-planos')}><PlanoContasPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/parametros"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-parametros')}><ParametrosPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/fechamento-fiscal"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-fech-fiscal')}><FechamentoFiscalPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/plano-contabil"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-plano-contabil')}><PlanoContabilPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/balancete"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-balancete')}><BalancetePage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/razao"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-razao')}><RazaoPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/diario"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-diario')}><DiarioPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/dre"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-dre')}><DrePage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/dre/estrutura"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-dre-estrutura')}><DreEstruturaPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/mapeamento-contabil"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-mapeamento')}><MapeamentoContabilPage /></RequerPermissaoRota>}
              />
              <Route
                path="/contabilidade/lancamentos"
                element={<RequerPermissaoRota codigo={leituraDaTela('cont-lancamentos')}><LancamentosPage /></RequerPermissaoRota>}
              />
              <Route
                path="/financeiro/centro-de-custo"
                element={<RequerPermissaoRota codigo={leituraDaTela('fin-centros')}><CentroCustoPage /></RequerPermissaoRota>}
              />
              <Route path="/financeiro/orcamentos/:id" element={<OrcamentoBridgePage />} />
              {/* [MOD-03 AB#131] O detalhe do lead vive num DRAWER lateral
              dentro de /comercial/crm — sem rota dedicada. Deep-link
              direto (/comercial/crm/leads/:id) fica pra sprint futura. */}
              {/* [MOD-03 AB#117] Configuração de caixas de entrada (canais).
              Gating mod_03 = backend (mesmo padrão do InboxPage). */}
              <Route
                path="/settings/comercial/caixas"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-cmc')}><SettingsComercialCaixas /></RequerPermissaoRota>}
              />
              {/* [MOD-03 AB#157] Painel de configuração da Atena por caixa.
              Backend exige ADMIN_TENANT/GESTOR + mod_03. */}
              <Route path="/settings/comercial/caixas/:id/ia" element={<SettingsCaixaIa />} />
              {/* [MOD-03 AB#132] Configuração do CRM (estágios + campos
              customizados). Backend exige ADMIN_TENANT. */}
              <Route
                path="/settings/comercial/crm"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-crm')}><SettingsComercialCrm /></RequerPermissaoRota>}
              />
              {/* [#890 item 1, 2026-09-28] Automações e Respostas rápidas ganharam recurso
              RBAC dedicado — gate de rota igual ao resto do app. */}
              <Route
                path="/settings/automacoes"
                element={<RequerPermissaoRota codigo={leituraDaTela('atd-automacoes')}><AutomacoesPage /></RequerPermissaoRota>}
              />
              {/* [AB#449 / ADR-045] Respostas rápidas do inbox. Backend gating
              @Modulo('mod_03'); a permissão por ESCOPO (compartilhado exige
              ADMIN_TENANT/GESTOR, pessoal qualquer perfil) vive no service — o
              RequerPermissaoRota aqui só cobre o `:ler` de entrar na tela. */}
              <Route
                path="/settings/automacoes/templates-atendimento"
                element={<RequerPermissaoRota codigo={leituraDaTela('atd-respostas-rapidas')}><TemplatesAtendimentoPage /></RequerPermissaoRota>}
              />
              {/* [AB#264] Config de campanhas e Opt-outs viraram tabs do guarda-chuva
              /comercial/campanhas. Rotas antigas redirecionam p/ deep-links salvos. */}
              <Route
                path="/settings/comercial/campanhas"
                element={<Navigate replace to="/comercial/campanhas?tab=configuracoes" />}
              />
              <Route
                path="/settings/comercial/opt-outs"
                element={<Navigate replace to="/comercial/campanhas?tab=opt-outs" />}
              />
              <Route
                path="/settings/users"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-usu')}><SettingsUsers /></RequerPermissaoRota>}
              />
              <Route
                path="/settings/perfis"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-perfis')}><SettingsPerfis /></RequerPermissaoRota>}
              />
              <Route path="/settings/perfis/:id" element={<SettingsPerfilEditor />} />
              <Route
                path="/settings/estabelecimentos"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-est')}><SettingsEstabelecimentos /></RequerPermissaoRota>}
              />
              <Route
                path="/settings/empresa"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-emp')}><SettingsEmpresa /></RequerPermissaoRota>}
              />
              <Route
                path="/settings/integracoes"
                element={<RequerPermissaoRota codigo={leituraDaTela('cfg-integracoes')}><SettingsIntegracoes /></RequerPermissaoRota>}
              />
              <Route
                path="/audit-log"
                element={<RequerPermissaoRota codigo={leituraDaTela('auditoria')}><AuditLog /></RequerPermissaoRota>}
              />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/minha-conta/perfil" element={<MinhaContaPerfil />} />
              {/* [AB#196] Retorno do OAuth do Google Calendar (callback do backend
              redireciona pra cá). */}
              <Route path="/agenda/google/sucesso" element={<GoogleCalendarSucesso />} />
              <Route path="/minha-conta/chamados" element={<MinhaContaChamados />} />
              <Route path="/minha-conta/chamados/:id" element={<MinhaContaChamadoDetalhe />} />
              <Route path="/minha-conta/notas-fiscais" element={<MinhaContaNotasFiscais />} />
              {/* [UI-ASSINATURA] Tela única consolidada. As subrotas /plano e
              /pagamento-metodo foram removidas (lógica absorvida aqui);
              /pagamentos continua existindo só pro histórico completo
              paginado, acessado pelo link "Ver todas" dentro desta tela.
              [Decisão de produto 2026-09-28 / ADR-069 §13.7] As 3 rotas exigem
              config.assinatura:ler — por padrão só o Administrador. */}
              <Route
                path="/minha-conta/assinatura"
                element={<RequerPermissaoRota codigo={leituraDaTela('mc-ass')}><MinhaContaAssinatura /></RequerPermissaoRota>}
              />
              <Route
                path="/minha-conta/assinatura/extrato-ia"
                element={<RequerPermissaoRota codigo={leituraDaTela('mc-ass')}><ExtratoIaPage /></RequerPermissaoRota>}
              />
              <Route
                path="/minha-conta/assinatura/pagamentos"
                element={<RequerPermissaoRota codigo={leituraDaTela('mc-ass')}><MinhaContaAssinaturaPagamentos /></RequerPermissaoRota>}
              />
              <Route path="/minha-conta/proposta-segmento/:id" element={<PropostaSegmento />} />
            </Route>

            {/* /admin/* — todas as rotas do Super Admin envolvidas pelo AdminLayout
            do Design System v2 [UI-F1]. Sidebar + topbar + breadcrumb são
            renderizados pelo shell; cada folha mantém o `AdminRoute` por
            defense-in-depth (REQ-005 — guard de perfil sobreposto ao do AppShell). */}
            <Route element={<AdminLayout />}>
              <Route
                path="/admin/impersonate"
                element={
                  <AdminRoute>
                    <AdminImpersonate />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/segmentos"
                element={
                  <AdminRoute>
                    <AdminSegmentos />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/faturamento-vinya"
                element={
                  <AdminRoute>
                    <AdminFaturamentoVinya />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/system-settings"
                element={
                  <AdminRoute>
                    <AdminSystemSettings />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/modulos"
                element={
                  <AdminRoute>
                    <AdminModulos />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/templates-mensagem"
                element={
                  <AdminRoute>
                    <AdminTemplatesMensagem />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/documentos-legais"
                element={
                  <AdminRoute>
                    <AdminDocumentosLegais />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/release-notes"
                element={
                  <AdminRoute>
                    <AdminReleaseNotes />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/comunicados"
                element={
                  <AdminRoute>
                    <AdminComunicados />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/dashboard"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/planos"
                element={
                  <AdminRoute>
                    <AdminPlanos />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/tenants"
                element={
                  <AdminRoute>
                    <AdminTenants />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/tenants/:id"
                element={
                  <AdminRoute>
                    <AdminTenantDetalhe />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/audit-log"
                element={
                  <AdminRoute>
                    <AdminAuditLog />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/chamados"
                element={
                  <AdminRoute>
                    <AdminChamados />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/chamados/:id"
                element={
                  <AdminRoute>
                    <AdminChamadoDetalhe />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/faq"
                element={
                  <AdminRoute>
                    <AdminFaq />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/inadimplencia"
                element={
                  <AdminRoute>
                    <AdminInadimplencia />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/financeiro/operacoes"
                element={
                  <AdminRoute>
                    <AdminFinanceiroOperacoes />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/sistema/monitoramento"
                element={
                  <AdminRoute>
                    <AdminSistemaMonitoramento />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/perfil"
                element={
                  <AdminRoute>
                    <AdminPerfil />
                  </AdminRoute>
                }
              />
            </Route>

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Suspense>
        </ErrorBoundaryDeRota>
      </ToastProvider>
    </BrowserRouter>
  );
}

/**
 * [PERF] Loader que aparece enquanto o chunk lazy da rota baixa.
 *
 * Fundo `bg-bg-app` (mesma cor do <main> do AppShell) — sem isso o
 * Suspense renderizava sobre fundo branco, criando um flash. Spinner
 * teal centralizado segue o ADR-020.
 *
 * Para rotas FORA do AppShell (Login, Register, etc.), o Suspense
 * mesmo assim cobre a área inteira do viewport via `min-h-[60vh]` +
 * `flex items-center justify-center`.
 */
function PageSkeleton(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-bg-app p-8">
      <div
        aria-label="Carregando"
        role="status"
        className="h-8 w-8 animate-spin rounded-full border-2 border-border-v2 border-t-[var(--brand-500)]"
      />
    </div>
  );
}
